import type { Store } from "@/common/storeUtils";
import { createParentComponent, type GaVueComponent } from "@/common/vueUtils";
import { GaChip } from "@/components/general/GaChip";

export type TabsOption<T extends string> = { value: T; label: string };
export const GaTabs = <T extends string>(props: { tabOptions: TabsOption<T>[]; store: Store<T> }): GaVueComponent => {
  return (
    <div class="d-flex gap-3 mt-5 mb-5 flex-wrap">
      {props.tabOptions.map((tab) => {
        return (
          <GaChip
            active={props.store.get() === tab.value}
            changeHandler={() => {
              props.store.set(tab.value);
              console.log(tab.value);
            }}
            value={tab.value}
            type="radio"
            name="contentTypeTabs">
            {tab.label}
          </GaChip>
        );
      })}
    </div>
  );
};

export const TabContent = createParentComponent<{ active: boolean; error?: GaVueComponent; loading?: GaVueComponent }>((props) => {
  if (props.error !== undefined) {
    return props.error;
  }
  if (props.loading !== undefined) {
    return props.loading;
  }
  if (props.active) {
    return <>{props.children}</>;
  } else {
    return <></>;
  }
});
